<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-6">
        <template v-if="state==='loaded'">
            <ui-header :title="`Defect ${defect.reference}`"
                       :subtitle="'ID #'+this.defect.id">
                <template #actions>
                    <ui-button-new icon="fas fa-arrow-left" @click="finished()">Done</ui-button-new>
                </template>
            </ui-header>

            <ui-tabs active="overview" class="mt-6" :tabs="tabs" #default="{ isActive }">
                <!-- Overview. -->
                <div v-if="isActive('overview')">
                    <ui-data-grid>
                        <ui-data-grid-item label="Package" v-if="!packageReference">
                            <template>{{ defect.packageName }}</template>
                        </ui-data-grid-item>
                        <ui-data-grid-item label="Description of Problem" wide>
                            <ui-textarea autoresize name="descriptionOfProblem"
                                         v-model="defect.descriptionOfProblem"
                                         placeholder="Full description of the problem..."
                                         @input="save"
                                         class=""></ui-textarea>
                        </ui-data-grid-item>
                        <ui-data-grid-item label="Required to Make Good" :value="defect.requiredToMakeGood"
                                           wide>
                            <ui-textarea autoresize name="requiredToMakeGood"
                                         v-model="defect.requiredToMakeGood"
                                         placeholder="What is required to resolve the identified issue?..."
                                         @input="save"
                                         class=""></ui-textarea>

                        </ui-data-grid-item>
                        <ui-data-grid-item wide>
                            <ui-input-file-inline label="Image, Videos and PDFs"
                                                  name="media[]"
                                                  :filesystemId="defect.filesystemId"
                                                  :readonly="false"
                                                  :attachUrl="attachUrl"
                                                  :detachUrl="detachUrl"
                                                  :downloadUrl="downloadUrl"
                                                  :current-files="getDefectFiles"></ui-input-file-inline>
                        </ui-data-grid-item>
                    </ui-data-grid>
                    <ui-data-grid-item class="mt-8" label="Quick action" wide
                                       v-if="defect.status==='Draft' || defect.status==='Sent'">
                        <div class="flex flex-col md:flex-row flex-wrap -m-2">
                            <ui-button-new class="m-2" icon="fas fa-route" extra
                                           @click="sendForCompletion"
                            >Finish & Send for Completion
                            </ui-button-new>
                        </div>
                    </ui-data-grid-item>

                    <ui-data-grid class="mt-6">
                        <ui-data-grid-item label="Created By">{{ defect.createdBy }} on {{ defect.createdOn }}
                        </ui-data-grid-item>
                        <ui-data-grid-item label="Last Updated By" v-if="defect.lastUpdatedBy">{{
                                defect.lastUpdatedBy
                            }} on {{
                                defect.lastUpdatedOn
                            }}
                        </ui-data-grid-item>
                    </ui-data-grid>
                </div>

                <!-- Notes. -->
                <div v-else-if="isActive('notes')" style="height:calc(100vh - 400px);">
                    <notes-v2 :get-url="defect.getNotesUrl()" :post-url="defect.postNotesUrl()"></notes-v2>
                </div>

            </ui-tabs>
        </template>
    </div>
</template>

<script>
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiHeader from "../../ui/UiHeader.vue";
import moment from "moment";
import {debounce} from "lodash";
import {readonly} from "vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";

import {Defect} from '@models'
import NotesV2 from "../../NotesV2.vue";
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";

export default {
    components: {AutoresizableTextarea, NotesV2, UiButtonNew, UiDataGrid, UiDataGridItem, UiHeader},
    props: {
        item: Object,
        packageReference: null,
        fsModal: Object,
        setEditMode: Function,
    },
    data() {
        return {
            defect: {},
            tabs: [
                {value: 'overview', label: 'Overview'},
                {value: 'notes', label: 'Notes'},
            ],
            busy: false,
            moment,
            state: 'loading',
            debouncedUpdate: debounce(this.update, 300),
        }
    },
    computed: {
        editMode() {
            return !!this.item
        },
    },
    methods: {
        readonly,
        async sendForCompletion() {
            this.save();
            this.$emit('finishAndSend');
        },
        attachUrl(id) {
            return route('api.v2.hsqe.defect.file.attach', {
                'package_reference': this.packageReference,
                'id': this.item.id,
                'file_id': id
            })
        },
        detachUrl(id) {
            return route('api.v2.hsqe.defect.file.detach', {
                'package_reference': this.packageReference,
                'id': this.item.id,
                'file_id': id
            })
        },
        downloadUrl(id) {
            return route('api.v2.hsqe.defect.file.download', {
                'package_reference': this.packageReference,
                'id': this.item.id,
                'file_id': id
            })
        },
        async getDefectFiles() {
            let data = await Defect.find(this.packageReference, this.item.id)
            return data.files
        },
        async update() {
            await this.defect.update();
            Object.assign(this.item, await Defect.find(this.packageReference, this.item.id));
            this.defect.lastUpdatedBy = this.item.lastUpdatedBy
            this.defect.lastUpdatedOn = this.item.lastUpdatedOn
            this.defect.status = this.item.status
        },
        async save() {
            this.debouncedUpdate();
        },
        finished() {
            this.setEditMode(false)
        }
    },
    async mounted() {
        this.defect = await Defect.find(this.packageReference, this.item.id)
        this.state = 'loaded'
    }
}
</script>
